/**
 * cld-cart-estimate-request.js
 * カートページの見積もり依頼モーダル
 */
(function () {
  'use strict';

  var btn = document.getElementById('cld-cart-quote-btn');
  if (!btn) return;
  console.log('[cld-cart-estimate-request] v2 loaded (EmailJS enabled)');

  var cartImageUrl = '';
  var cartImagesHtml = '';

  /* ── モーダル HTML を挿入 ── */
  var modal = document.createElement('div');
  modal.id = 'cld-cart-quote-modal';
  modal.className = 'cld-quote-modal';
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('role', 'dialog');
  modal.innerHTML = [
    '<div class="cld-quote-modal-inner">',
    '  <button type="button" class="cld-quote-modal-close" aria-label="閉じる">×</button>',
    '  <div id="cld-cart-quote-modal-body">',
    '    <h2 class="cld-quote-modal-title">見積もりを依頼する</h2>',
    '    <p class="cld-quote-modal-note">カート内の内容でお見積もりを依頼します。必須項目をご入力の上、送信してください。</p>',
    '    <div id="cld-cart-quote-preview" class="cld-quote-preview"></div>',
    '    <div class="cld-quote-field-wrap">',
    '      <label class="cld-quote-field-label" for="cld-cart-quote-company">会社名 <span class="cld-quote-required">必須</span></label>',
    '      <input type="text" id="cld-cart-quote-company" class="cld-quote-field-input" placeholder="株式会社〇〇" required>',
    '    </div>',
    '    <div class="cld-quote-field-wrap">',
    '      <label class="cld-quote-field-label" for="cld-cart-quote-name">氏名 <span class="cld-quote-required">必須</span></label>',
    '      <input type="text" id="cld-cart-quote-name" class="cld-quote-field-input" placeholder="山田 太郎" required>',
    '    </div>',
    '    <div class="cld-quote-field-wrap">',
    '      <label class="cld-quote-field-label" for="cld-cart-quote-tel">電話番号 <span class="cld-quote-required">必須</span></label>',
    '      <input type="tel" id="cld-cart-quote-tel" class="cld-quote-field-input" placeholder="000-0000-0000" required>',
    '    </div>',
    '    <div class="cld-quote-field-wrap">',
    '      <label class="cld-quote-field-label" for="cld-cart-quote-email">メールアドレス <span class="cld-quote-required">必須</span></label>',
    '      <input type="email" id="cld-cart-quote-email" class="cld-quote-field-input" placeholder="info@example.com" required>',
    '      <p class="cld-quote-email-note">店舗からの返信がこのアドレスに届きます。</p>',
    '    </div>',
    '    <div class="cld-quote-field-wrap">',
    '      <label class="cld-quote-field-label" for="cld-cart-quote-notes">その他 <span class="cld-quote-optional">任意</span></label>',
    '      <textarea id="cld-cart-quote-notes" class="cld-quote-field-textarea" rows="4" placeholder="見積に関して必要事項をご記入ください。"></textarea>',
    '    </div>',
    '    <button type="button" id="cld-cart-quote-submit" class="cld-quote-submit-btn">送信する</button>',
    '  </div>',
    '  <div id="cld-cart-quote-thanks" class="cld-quote-thanks hidden">',
    '    <p class="cld-quote-thanks-icon">✓</p>',
    '    <h2 class="cld-quote-modal-title">送信しました</h2>',
    '    <p class="cld-quote-thanks-text">見積もり依頼を受け付けました。<br>担当者より折り返しご連絡いたします。</p>',
    '    <button type="button" class="cld-quote-modal-close cld-quote-close-btn">閉じる</button>',
    '  </div>',
    '</div>'
  ].join('');
  document.body.appendChild(modal);

  function qs(id) { return document.getElementById(id); }

  function formatPrice(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function formatYen(n) {
    return '¥' + n.toLocaleString('ja-JP');
  }

  function buildCartLines(cartData) {
    var lines = [];
    var allItems = cartData.items || [];
    var mainItems = allItems.filter(function (item) {
      return !(item.properties && item.properties['_fee_for']);
    });
    if (mainItems.length === 0) {
      lines.push('■ カート内容');
      lines.push('（カートは空です）');
      return lines;
    }

    /* 画像HTML収集 */
    var imagesHtml = '';
    mainItems.forEach(function (item) {
      var rawImg = item.image || (item.featured_image && item.featured_image.url) || '';
      if (rawImg) {
        if (rawImg.indexOf('//') === 0) rawImg = 'https:' + rawImg;
        else if (rawImg.indexOf('/') === 0) rawImg = window.location.origin + rawImg;
        imagesHtml += '<img src="' + rawImg + '" width="100" style="max-width:100px;margin:4px 8px 4px 0;border-radius:4px;vertical-align:top;" alt="商品画像">';
      }
    });
    cartImagesHtml = imagesHtml;
    cartImageUrl = '';

    /* fee itemをメイン商品のkeyで紐付け */
    var feeByKey = {};
    allItems.forEach(function (item) {
      if (item.properties && item.properties['_fee_for']) {
        var key = item.properties['_fee_for'];
        if (!feeByKey[key]) feeByKey[key] = [];
        feeByKey[key].push(item);
      }
    });

    var grandSubtotal = 0;

    mainItems.forEach(function (item, idx) {
      if (idx > 0) lines.push('');

      /* SKU（variant_titleまたはsku） */
      var sku = item.sku || (item.variant_title || '');

      /* 小計 = メイン商品 + fee items */
      var itemSubtotal = item.line_price;
      var fees = feeByKey[item.key] || [];
      fees.forEach(function (fee) { itemSubtotal += fee.line_price; });

      /* discount_allocations を差し引き */
      var discounts = item.discount_allocations || [];
      discounts.forEach(function (d) {
        var amount = d.amount ? parseInt(d.amount, 10) : 0;
        if (amount > 0) itemSubtotal -= amount;
      });

      /* 1冊単価 */
      var qty = item.quantity || 1;
      var unitPrice = Math.round(itemSubtotal / qty / 100);
      var subtotalYen = Math.round(itemSubtotal / 100);
      var tax = Math.floor(subtotalYen * 0.1);
      var total = subtotalYen + tax;

      grandSubtotal += subtotalYen;

      lines.push('■ お見積もり内容');
      lines.push('商品名: ' + item.product_title);
      if (sku) lines.push('商品コード: ' + sku);
      lines.push('商品URL: ' + window.location.origin + item.url);
      lines.push('数量: ' + qty + '部');
      lines.push('1冊単価: ' + formatYen(unitPrice));
      lines.push('小計: ' + formatYen(subtotalYen));
      lines.push('消費税: ' + formatYen(tax));
      lines.push('合計: ' + formatYen(total));

      /* ■ 名入れ情報 */
      var props = item.properties || {};
      var propKeys = Object.keys(props);
      var naireLines = [];
      propKeys.forEach(function (key) {
        if (key.charAt(0) === '_') return;
        var val = (props[key] || '').toString().trim();
        if (!val) return;
        naireLines.push(key + ': ' + val);
      });
      if (naireLines.length > 0) {
        lines.push('');
        lines.push('■ 名入れ情報');
        naireLines.forEach(function (l) { lines.push(l); });
      }
    });

    /* 全商品合計 */
    if (mainItems.length > 1) {
      var grandTax = Math.floor(grandSubtotal * 0.1);
      var grandTotal = grandSubtotal + grandTax;
      lines.push('');
      lines.push('────────────');
      lines.push('総小計: ' + formatYen(grandSubtotal));
      lines.push('消費税: ' + formatYen(grandTax));
      lines.push('総合計: ' + formatYen(grandTotal));
    }

    return lines;
  }

  function renderPreview(lines) {
    var preview = qs('cld-cart-quote-preview');
    if (preview) preview.textContent = lines.join('\n');
  }

  function openModal() {
    renderPreview(['（カート情報を読み込み中...）']);
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderPreview(buildCartLines(cart)); })
      .catch(function () { renderPreview(['（カート情報の取得に失敗しました）']); });
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      var body = qs('cld-cart-quote-modal-body');
      var thanks = qs('cld-cart-quote-thanks');
      if (body) body.classList.remove('hidden');
      if (thanks) thanks.classList.add('hidden');
      ['cld-cart-quote-company','cld-cart-quote-name','cld-cart-quote-tel','cld-cart-quote-email','cld-cart-quote-notes'].forEach(function(id) {
        var el = qs(id); if (el) el.value = '';
      });
      var submitBtn = qs('cld-cart-quote-submit');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = '送信する'; }
    }, 300);
  }

  function submitQuote() {
    var companyInput = qs('cld-cart-quote-company');
    var nameInput    = qs('cld-cart-quote-name');
    var telInput     = qs('cld-cart-quote-tel');
    var emailInput   = qs('cld-cart-quote-email');
    var notesInput   = qs('cld-cart-quote-notes');

    var requiredFields = [companyInput, nameInput, telInput, emailInput];
    for (var i = 0; i < requiredFields.length; i++) {
      var f = requiredFields[i];
      if (!f || !f.value.trim() || !f.validity.valid) {
        if (f) { f.focus(); f.reportValidity(); }
        return;
      }
    }

    var submitBtn = qs('cld-cart-quote-submit');
    submitBtn.disabled = true;
    submitBtn.textContent = '送信中...';

    var preview = qs('cld-cart-quote-preview');
    var bodyText = [
      '■ お客様情報',
      '会社名：' + companyInput.value.trim(),
      '氏名：'   + nameInput.value.trim(),
      '電話番号：' + telInput.value.trim(),
      'メール：'  + emailInput.value.trim(),
      '',
      '■ その他・ご要望',
      notesInput.value.trim(),
      '',
      (preview ? preview.textContent : ''),
      '',
      '※ このメールはカートからの見積もり依頼です。ご返信をお待ちください。'
    ].join('\n');
    var email = emailInput.value.trim();

    var contactForm = document.getElementById('cld-cart-quote-form');
    var emailField  = document.getElementById('cld-cart-quote-form-email');
    var bodyField   = document.getElementById('cld-cart-quote-form-body');

    if (!contactForm || !emailField || !bodyField) {
      submitBtn.disabled = false;
      submitBtn.textContent = '送信する';
      alert('フォームの初期化に失敗しました。ページを再読み込みしてください。');
      return;
    }

    emailField.value = email;
    bodyField.value  = bodyText;

    fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        service_id: 'service_jssou81',
        template_id: 'template_6d5b15x',
        user_id: 'CCjjuY4LqzkYNnLNR',
        template_params: {
          to_email: email,
          email: email,
          company_name: companyInput.value.trim(),
          customer_name: nameInput.value.trim(),
          body: (preview ? preview.textContent : '') + (notesInput.value.trim() ? '\n\n■ その他・ご要望\n' + notesInput.value.trim() : ''),
          product_images_html: cartImagesHtml
        }
      })
    }).finally(function () {
      contactForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }

  /* 送信後リダイレクトで戻ってきた場合 */
  if (window.location.search.indexOf('estimate=sent') !== -1) {
    var toast = document.createElement('div');
    toast.className = 'cld-quote-toast';
    toast.textContent = '見積もり依頼を受け付けました。ご入力のメールアドレスへ担当者よりご連絡いたします。';
    document.body.appendChild(toast);
    setTimeout(function () { toast.classList.add('is-visible'); }, 100);
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 400);
      history.replaceState(null, '', window.location.pathname + window.location.hash);
    }, 5000);
  }

  btn.addEventListener('click', openModal);

  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('cld-quote-modal-close')) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  var submitBtn = qs('cld-cart-quote-submit');
  if (submitBtn) submitBtn.addEventListener('click', submitQuote);

})();
